(function() {
    'use strict';
    angular.module('approot',['app','appback']);
})();
(function() {
    'use strict';
    angular.module('appback',['wipImageZoom','mrImage','dndLists','chieffancypants.loadingBar','angular.filter','ngSanitize','ngFileUpload','ui.bootstrap','iso.directives']).config(function($httpProvider,cfpLoadingBarProvider) {
   		// $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
    	$httpProvider.defaults.headers.post['X-CSRF-Token'] = jQuery('meta[name="csrf-token"]').attr("content");
 	    $httpProvider.defaults.timeout = 30000;
	}).config(["$interpolateProvider",function($interpolateProvider){
        $interpolateProvider.startSymbol("[[");
        $interpolateProvider.endSymbol("]]");
    }])


})();
 